import BaseRequest from './BaseRequest';
import { API_URL } from '../config/config';

const ParametrosRequest = () => {
    // let apiurl = process.env.REACT_APP_URL + API_URL;
    
    return {
        buscarInstituicao() {
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/instituicao`,
                { headers: BaseRequest.publicHeaders },
            );
        },
        buscarDadosSecao1() {
            return BaseRequest.axiosInst.get(`${API_URL}/parametros/secao_1`, {
                headers: BaseRequest.publicHeaders,
            });
        },
        buscaDadosSecao2(tipo_catalogo, cod_biblioteca, cancelToken = null) {
            return BaseRequest.axiosInst.get(`${API_URL}/parametros/secao_2`, {
                headers: BaseRequest.publicHeaders,
                cancelToken,
                params: { tipo_catalogo, cod_biblioteca }
            });
        },
        buscaFAQ(tipo_catalogo, cancelToken = null) {
            return BaseRequest.axiosInst.get(`${API_URL}/parametros/faq`, {
                headers: BaseRequest.publicHeaders,
                params: {tipo_catalogo},
                cancelToken
            });
        },
        buscaInformacoesGerais(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/informacoes_gerais`,
                { headers: BaseRequest.publicHeaders, cancelToken },
            );
        },
        buscarFuncionalidades() {
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/funcionalidades`,
                { headers: BaseRequest.publicHeaders },
            );
        },
        buscarFuncionalidade(codAtividade) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/atividade/${codAtividade}`,
                { headers: BaseRequest.publicHeaders },
            );
        },
        buscarDadosAtendimento(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/atendimento`,
                { headers: BaseRequest.publicHeaders, cancelToken},
            );
        },
        buscarDadosAtendimentoCampus(codCampus) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/atendimento/${codCampus}`,
                { headers: BaseRequest.publicHeaders },
            );
        },
        buscaEventosInstitucionais(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/eventos_institucionais`,
                { headers: BaseRequest.publicHeaders ,cancelToken},
            );
        },
        buscaEventosEventum(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/eventos_eventum`,
                { headers: BaseRequest.publicHeaders , cancelToken},
            );
        },
        buscaMensagemInformativaPorAtividade(codAtividade) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/atividade/${codAtividade}/informativo`,
                { headers: BaseRequest.publicHeaders },
            );
        },
        validaAutoatendimento() {
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/autoatendimento`,
                { headers: BaseRequest.publicHeaders },
            );
        },
        buscarParametrosAppLayers(){
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/app-layers`,
                { headers: BaseRequest.publicHeaders },
            );
        },
        getLastCacheDate() {
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/get-last-cache-date`,
                { headers: BaseRequest.publicHeaders },
            );
        },
        buscaDadosPrefiltros(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/prefiltros`,
                { headers: BaseRequest.publicHeaders, cancelToken },
            );
        },
        buscaPluginCustomizado(cancelToken = null){
            return BaseRequest.axiosInst.get(
                `${API_URL}/parametros/custom-plugin`,
                { headers: BaseRequest.publicHeaders, cancelToken },
            );
        }
    };
};
export default ParametrosRequest();
